
import { localizedText } from '../../common-js/LanguageMap';
import getStripeKey from '../../common-js/stripe-settings';

/* eslint-disable no-param-reassign */
// multiStateAddonApp.controller('PaymentController', ($scope, $state, $log, $timeout, DrawpService, $stateParams, $sessionStorage) => {
export default function ($scope, $state, $log, $timeout, DrawpService, $stateParams, $sessionStorage) {
    $scope.localizedText = localizedText;
    const GOOGLE_SLIDE_EN_JOURNAL_BUNDLE_SUBSCRIPTION = '5f7fdefd618072070fc2b904';
    const GOOGLE_SLIDE_ES_JOURNAL_BUNDLE_SUBSCRIPTION = '5f7fdefd618072070fc2b905';

    const MICROSOFT_ADDIN_GRAPHIC_ORGANIZER_SUBSCRIPTION = '6603b1a0e4b0f12b1a345678'
    const MICROSOFT_ADDIN_LVL3_SCAFFOLDING_SUBSCRIPTION = '6603b1a1e4b0f12b1a345679'
    const MICROSOFT_ADDIN_LVL4_SCAFFOLDING_SUBSCRIPTION = '6603b1a1e4b0f12b1a345680'
    const MICROSOFT_ADDIN_LVL6_SCAFFOLDING_SUBSCRIPTION = '6603b1a1e4b0f12b1a345681'
    const MICROSOFT_ADDIN_EN_MATH_JOURNAL_BUNDLE_SUBSCRIPTION = '6603b1a2e4b0f12b1a34567a'
    const MICROSOFT_ADDIN_ES_MATH_JOURNAL_BUNDLE_SUBSCRIPTION = '6603b1a3e4b0f12b1a34567b'

    const INVALID_COUPON_MESSAGE = 'Coupon is not valid.';

    $scope.stateTitle = 'Payment';
    $scope.paymentTitle = '';
    $scope.paymentSubtitle = '';
    $scope.bundleId = '';
    $scope.prices = [];
    $scope.serverToken = '';

    if ($stateParams.tool === "0") {
        $scope.bundleId = MICROSOFT_ADDIN_GRAPHIC_ORGANIZER_SUBSCRIPTION;
        $scope.backState = 'graphicOrganizers';
        $scope.paymentTitle = 'Drawp Basic Subscription Access';
        $scope.paymentSubtitle = 'The Drawp Basic Subscription provides you access to all of the premium content of tools Graphic Organizer, Lesson Plans and the translation tools available in the Drawp for School add-in for Microsoft PowerPoint.';
    } else if ($stateParams.tool === "3") {
        $scope.bundleId = MICROSOFT_ADDIN_LVL3_SCAFFOLDING_SUBSCRIPTION;
        $scope.paymentTitle = 'Fill-in-the-Blank Frames (Level 3) Premium Subscription Access';
        $scope.paymentSubtitle = 'The Fill-in-the-Blank Frames (Level 3) Premium Subscription provides you access to all of the premium content of tool Fill-in-the-Blank Frames (Level 3) in the Drawp for School add-in for Microsoft PowerPoint.';
        $scope.backState = 'scaffoldingLevel3';
    } else if ($stateParams.tool === "4") {
        $scope.bundleId = MICROSOFT_ADDIN_LVL4_SCAFFOLDING_SUBSCRIPTION;
        $scope.paymentTitle = 'Fill-in-the-Blank Frames (Level 4) Premium Subscription Access';
        $scope.paymentSubtitle = 'The Fill-in-the-Blank Frames (Level 4) Premium Subscription provides you access to all of the premium content of tool Fill-in-the-Blank Frames (Level 4) in the Drawp for School add-in for Microsoft PowerPoint.';
        $scope.backState = 'scaffoldingLevel4';
    } else if ($stateParams.tool === "6") {
        $scope.bundleId = MICROSOFT_ADDIN_LVL6_SCAFFOLDING_SUBSCRIPTION;
        $scope.paymentTitle = 'Fill-in-the-Blank Frames (Level 6) Premium Subscription Access';
        $scope.paymentSubtitle = 'The Fill-in-the-Blank Frames (Level 6) Premium Subscription provides you access to all of the premium content of tool Fill-in-the-Blank Frames (Level 6) in the Drawp for School add-in for Microsoft PowerPoint.';
        $scope.backState = 'scaffoldingLevel6';
    } else if ($stateParams.tool === "7" || $stateParams.tool === "8") {
        $scope.bundleId = MICROSOFT_ADDIN_GRAPHIC_ORGANIZER_SUBSCRIPTION;
        $scope.paymentTitle = 'Drawp Basic Subscription Access';
        $scope.paymentSubtitle = 'The Drawp Basic Subscription provides you access to all of the premium content of tools Graphic Organizer and Lesson Plans in the Drawp for School add-in for Microsoft PowerPoint.';
        $scope.backState = 'lessonPlanList';
    } else if ($stateParams.tool === "10") {
        $scope.bundleId = GOOGLE_SLIDE_EN_JOURNAL_BUNDLE_SUBSCRIPTION;
        $scope.paymentTitle = 'My Academic Vocabulary Journal (English) by Velázquez Press';
        $scope.paymentSubtitle = 'This subscription provides you access to the content of the My Academic Vocabulary Journal (English) by Velázquez Press.';
        $scope.backState = 'vpAcademicJournals';
    } else if ($stateParams.tool === "11") {
        $scope.bundleId = GOOGLE_SLIDE_ES_JOURNAL_BUNDLE_SUBSCRIPTION;
        $scope.paymentTitle = 'My Academic Vocabulary Journal (Spanish) by Velázquez Press';
        $scope.paymentSubtitle = 'This subscription provides you access to the content of the My Academic Vocabulary Journal (Spanish) by Velázquez Press.';
        $scope.backState = 'vpAcademicJournals';
    } else if ($stateParams.tool === "12") {
        $scope.bundleId = MICROSOFT_ADDIN_EN_MATH_JOURNAL_BUNDLE_SUBSCRIPTION;
        $scope.paymentTitle = 'My Academic Math Journal (English) by Velázquez Press';
        $scope.paymentSubtitle = 'This subscription provides you access to the content of the My Academic Math Journal (English) by Velázquez Press.';
        $scope.backState = 'vpMathJournals';
    } else if ($stateParams.tool === "13") {
        $scope.bundleId = MICROSOFT_ADDIN_ES_MATH_JOURNAL_BUNDLE_SUBSCRIPTION;
        $scope.paymentTitle = 'My Academic Math Journal (Spanish) by Velázquez Press';
        $scope.paymentSubtitle = 'This subscription provides you access to the content of the My Academic Math Journal (Spanish) by Velázquez Press.';
        $scope.backState = 'vpMathJournals';
    } else if ($stateParams.tool === "15") {
        // Used for Translation Tool
        $scope.bundleId = MICROSOFT_ADDIN_GRAPHIC_ORGANIZER_SUBSCRIPTION;
        $scope.paymentTitle = 'Drawp Basic Subscription Access';
        $scope.paymentSubtitle = 'The Drawp Basic Subscription provides you access to all of the premium content of tools Graphic Organizer, Lesson Plans and the translation tools available in the Drawp for School add-in for Microsoft PowerPoint.';
        $scope.backState = 'slideTranslation';
    }

    const stripeBundlePricesPromise = DrawpService.getStripeBundlePrices($scope.bundleId, $scope.serverToken);
    const stripeDrawpBasicBundlePricesPromise = DrawpService.getStripeBundlePrices(MICROSOFT_ADDIN_GRAPHIC_ORGANIZER_SUBSCRIPTION, $scope.serverToken);
    const getActiveSubscriptionsPromise = DrawpService.getActiveSubscriptions();

    $scope.error = null;
    const progressText = $scope.localizedText('LOADING');
    $scope.progress = progressText;

    $scope.showSuccess = false;
    $scope.form_error = '';
    $scope.couponQuery = '';
    $scope.couponText = null;
    $scope.couponErrorText = null;

    let priceSelector = null;
    let elementEmail = null;
    let elementName = null;
    let elementCoupon = null;

    let elements = null;
    let card = null;
    let stripe = null;

    let selectedPriceValue = '';
    let selectedPriceAmount = 0;
    let tool = null;
    let language = null;
    let data1 = null;
    let data2 = null;

    let activeSubscriptions = [];

    $scope.basicBundlePrice = 0;
    let basicBundlePriceId = null;

    /**
     * Returns array with MICROSOFT_ADDIN_GRAPHIC_ORGANIZER_SUBSCRIPTION subscription detail if exists
     */
    const checkIfBasicSubscriptionActive = () => {
        return activeSubscriptions.filter(k => {
            return k.bundle_id === MICROSOFT_ADDIN_GRAPHIC_ORGANIZER_SUBSCRIPTION;
        });
    };

    const showProgress = (show, message) => {
        $timeout(() => {
            $scope.error = null;
            $scope.progress = null;
            if (show) {
                $scope.progress = message;
            }
        });
    };

    const showError = (show, message) => {
        $timeout(() => {
            $scope.error = null;
            $scope.progress = null;
            if (show) {
                $scope.error = message;
            }
        });
    };

    const initPaymentElement = () => {
        const stripeKey = getStripeKey();

        if (card) card.unmount();

        stripe = Stripe(stripeKey);

        var style = {
            base: {
                iconColor: '#42B070',
                color: 'rgba(0, 0, 0, 0.87)',  // Text color
                fontSize: '16px',
                fontFamily: 'Roboto, sans-serif',
                fontSmoothing: 'auto',
                '::placeholder': { color: '#aab7c4' },  // Placeholder text color
                backgroundColor: 'transparent',
                lineHeight: "28px"
            },
            invalid: {
                color: '#000',  // Error text color
                iconColor: '#d32f2f'  // Error icon color
            }
        };

        // removed: window.__exampleLocale
        elements = stripe.elements({
            payment_method_types: ['card'],
            mode: 'subscription',
            currency: 'usd',
            amount: selectedPriceAmount,
            paymentMethodCreation: 'manual',
            setupFutureUsage: 'off_session',
        });

        card = elements.create('card', {
            style: style,
            hidePostalCode: true
        });

        card.mount('#card-element');

        card.on('change', (event) => {
            if (event.complete) {
                DrawpService.gAGeneralPurchaseEvents('card_filled_in', tool, $scope.serverToken);
            }
        });

        showProgress(false, '');
    };

    const filterAndSetAmount = (priceId) => {
        const filterPriceObject = $scope.prices.filter(k => {
            return k.id === priceId;
        });

        selectedPriceAmount = filterPriceObject[0].unit_amount +
            $scope.basicBundlePrice;
    };

    const setupPriceSelector = () => {
        $timeout(() => {
            priceSelector = mdc.select.MDCSelect.attachTo(document.querySelector('#price-selector'));
            priceSelector.selectedIndex = 0;
            selectedPriceValue = priceSelector.value;
            filterAndSetAmount(selectedPriceValue);
            initPaymentElement();

            priceSelector.listen('MDCSelect:change', () => {
                if (selectedPriceValue !== priceSelector.value) {
                    DrawpService.gAChangeSubsTypeEvent('subscription_type_changed', tool, selectedPriceValue, priceSelector.value, $scope.serverToken);
                    selectedPriceValue = priceSelector.value;
                    filterAndSetAmount(selectedPriceValue);
                    initPaymentElement();
                }
            });
        });
    };

    angular.element(document).ready(() => {
        showProgress(true, 'Preparing Payment Form..');

        $scope.userEmail = DrawpService.getActiveUserEmail();
        $scope.serverToken = document.getElementById('serverToken').textContent.trim();
        tool = $stateParams.tool;
        $scope.tool = $stateParams.tool;
        language = $stateParams.language;
        data1 = $stateParams.data1;
        data2 = $stateParams.data2;

        $scope.lessonId = $stateParams.data1; // Needed if initiated from lesson plan detail

        DrawpService.gAPurchaseInitiatedEvent(tool, language, data1, data2, $scope.serverToken);

        Promise.all([
            getActiveSubscriptionsPromise,
            stripeBundlePricesPromise,
        ]).then((values) => {
            console.log(values);
            const promiseOneResponse = values[0].data;
            // const promiseOneResponse = JSON.parse(values[0]);
            activeSubscriptions = promiseOneResponse.subscriptions;

            // const promiseTwoResponse = JSON.parse(values[1]);
            const promiseTwoResponse = values[1].data;
            $timeout(() => {
                $scope.prices = promiseTwoResponse.data;
            });
        }).catch((err) => {
            $log.error('An error has occurred while fetching the active subscriptions and subscription detail.', err);
        }).finally(() => {
            elementEmail = mdc.textField.MDCTextField.attachTo(document.querySelector('#email'));
            elementEmail.disabled = true;
            elementEmail.value = $scope.userEmail;

            elementName = mdc.textField.MDCTextField.attachTo(document.querySelector('#name'));
            elementCoupon = mdc.textField.MDCTextField.attachTo(document.querySelector('#coupon'));

            const isBasicSubsriptionActive = checkIfBasicSubscriptionActive().length > 0;
            if (isBasicSubsriptionActive || $scope.bundleId === MICROSOFT_ADDIN_GRAPHIC_ORGANIZER_SUBSCRIPTION) {
                setupPriceSelector();
            } else {
                stripeDrawpBasicBundlePricesPromise.then((response) => {
                    const responseData = response.data;
                    // const responseData = JSON.parse(response);
                    $timeout(() => {
                        $scope.basicBundlePrice = responseData.data[0].unit_amount;
                        basicBundlePriceId = responseData.data[0].id;
                    });
                }).catch((err) => {
                    $log.error('An error has occurred while fetching the basic bundle subscription detail.', err);
                }).finally(() => {
                    setupPriceSelector();
                });
            }
        });
    });

    const processSubmitToken = (promises) => {
        Promise.all(promises).then((responses) => {
            $log.info(responses);

            if (responses[0].data == null) {
                showProgress(false, '');
                showError(true, 'The payment was unsuccessful. Please contact the card issuer.');
                DrawpService.gAPurchaseFailedEvent(tool, language, data1, data2, $scope.serverToken);
            } else {
                DrawpService.gAPurchaseCompletedEvent(tool, language, data1, data2, $scope.serverToken);
                $timeout(() => {
                    showProgress(false, '');
                    $scope.showSuccess = true;
                });
            }
        }).catch((error) => {
            // showError(true, error);
            showProgress(false, '');
            showError(true, 'The payment was unsuccessful. Please contact the card issuer.');
            DrawpService.gAPurchaseFailedEvent(tool, language, data1, data2, $scope.serverToken);
        });
    };

    $scope.submitPayment = () => {
        if (elementName.value === '') {
            $scope.form_error = 'Name is required';
            DrawpService.gAGeneralPurchaseEvents('purchase_btn_selected_with_missing_info', tool, $scope.serverToken);
        } else {
            $scope.form_error = '';
            if (!card) {
                console.error('Card element not initialized.');
                return;
            }

            stripe.createPaymentMethod({
                type: 'card',
                card: card,
                billing_details: {
                    name: elementName.value,
                    email: elementEmail.value,
                }
            }).then((result) => {
                if (result.error) {
                    $timeout(() => {
                        $scope.form_error = result.error.message;
                    });
                    DrawpService.gAGeneralPurchaseEvents('purchase_btn_selected_with_missing_info', tool, $scope.serverToken);
                } else {
                    showProgress(true, 'Processing purchase. Please do not close the window.');
                    DrawpService.gAGeneralPurchaseEvents('purchase_btn_selected_with_all_info', tool, $scope.serverToken);

                    console.log('Payment Method created:', result.paymentMethod.id);

                    var priceIds = [priceSelector.value];
                    const processPaymentMethodPromise = DrawpService.processPaymentMethod(priceIds, elementCoupon.value, elementName.value, result.paymentMethod.id, $scope.serverToken);
                    if (basicBundlePriceId != null) {
                        priceIds.push(basicBundlePriceId);
                        processSubmitToken([processPaymentMethodPromise]);
                    } else {
                        processSubmitToken([processPaymentMethodPromise]);
                    }
                }
            }).catch((err) => {
                $log.info(err);
            });

        }
    };

    $scope.closeDialog = () => {
        if ($scope.tool === '7') {
            $state.go('lessonPlanDetail', {
                'lessonPlanId': $scope.lessonId
            });
        } else {
            $state.go($scope.backState);
        }
    };

    $scope.focusOutCouponFunction = () => {
        const couponValue = elementCoupon.value;
        if (couponValue !== '') {
            DrawpService.gAGeneralPurchaseEvents('coupon_filled_in', tool, $scope.serverToken);
            DrawpService.getValidateCoupon(couponValue, $scope.serverToken).then((response) => {
                const data = response.data;
                $timeout(() => {
                    if (data == null) {
                        $scope.couponErrorText = INVALID_COUPON_MESSAGE;
                        $scope.couponText = null;
                    } else if (!data.valid) {
                        $scope.couponErrorText = INVALID_COUPON_MESSAGE;
                        $scope.couponText = null;
                    } else if (data.percent_off != null) {
                        $scope.couponErrorText = null;
                        $scope.couponText = `${data.percent_off} % discount will be applied to your purchase.`;
                    } else {
                        $scope.couponErrorText = null;
                        $scope.couponText = `USD ${data.amount_off} discount will be applied to your purchase.`;
                    }
                });
            }).catch(() => {
                $timeout(() => {
                    $scope.couponErrorText = INVALID_COUPON_MESSAGE;
                    $scope.couponText = null;
                });
            });
        } else {
            $timeout(() => {
                $scope.couponText = null;
            });
        }
    };

    $scope.onSubscriptionTypeClick = () => {
        DrawpService.gAGeneralPurchaseEvents('subscription_type_viewed', tool, $scope.serverToken);
    };

    $scope.onNameFilledIn = () => {
        const nameValue = elementName.value;
        if (nameValue !== '') {
            DrawpService.gAGeneralPurchaseEvents('name_filled_in', tool, $scope.serverToken);
        }
    };

    $scope.reloadCurrentPage = () => {
        $state.go($state.current.name, {}, { reload: true });
    };
};